import { createCites } from './createCites';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseMessage = (message: string, sources: any[]): string => {
	let isCite: boolean = false;
	const matches = {};
	let currentMatch = 0;
	return message
		.split('')
		.map((token) => {
			if (token === '[') {
				isCite = true;
				return '';
			} else if (token === ']') {
				isCite = false;
				return '. ';
			}
			if (isCite) {
				if (isNaN(Number.parseInt(token))) {
					return '';
				} else {
					if (matches[token]) {
						return createCites(matches[token]);
					} else {
						matches[token] = sources[currentMatch];
						currentMatch += 1;
						return createCites(matches[token]);
					}
				}
			} else {
				return token;
			}
		})
		.join('')
		.split('. <a')
		.map((phrase) => {
			if (phrase.includes('</a>')) {
				return `<a ${phrase}`;
			}
			return phrase;
		})
		.join('');
};
